import { render, staticRenderFns } from "./TrainingProfile.vue?vue&type=template&id=1c489202&"
import script from "./TrainingProfile.vue?vue&type=script&lang=js&"
export * from "./TrainingProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports